import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/new/14.png';
import _imports_1 from '../../assets/new/15.png';
import _imports_2 from '../../assets/new/16.png';
import _imports_3 from '../../assets/new/17.png';
const _withScopeId = n => (_pushScopeId("data-v-ad5b6dc6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "card"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_4 = {
  class: "link"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "javascript: void(0)"
}, "忘记密码?", -1));
const _hoisted_6 = {
  key: 0,
  class: "wx"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}), /*#__PURE__*/_createElementVNode("span", null, "社交账号快速登录"), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
})], -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
const _hoisted_9 = [_hoisted_8];
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router"; // 引入 useRoute
import { ElMessage } from "element-plus";
import { getLocalPid } from "../../libs/util";
import { userLogin, getSitename } from "../../api/index";

// 判断是否为移动设备

export default {
  __name: 'index_copy',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const inIFrame = function () {
      return window.self !== window.top;
    };
    const store = useStore();
    const router = useRouter();
    const route = useRoute(); // 使用 route 对象获取 URL 参数
    const username = ref("");
    const password = ref("");
    const siteName = ref(""); // 站点名称
    const bgImg = ref(""); // 背景图片链接

    // 登录处理函数
    const login = () => {
      let obj = {
        username: username.value,
        password: password.value
      };
      userLogin(encodeURIComponent(JSON.stringify(obj))).then(res => {
        let data = res.data;
        console.log(data);
        if (data.code === 0) {
          localStorage.setItem("ways", "login");
          // 将token保存到本地存储
          let msg = JSON.stringify(data.data);
          // userMes中包含userId和token
          localStorage.setItem("userMes", msg);
          localStorage.setItem("ways", "username");
          ElMessage.success(data.msg);
          store.commit("login", data.data);
          router.push({
            name: "my",
            query: {
              pid: getLocalPid()
            }
          });
        } else {
          ElMessage.error(data.msg);
        }
      }).catch(() => {
        ElMessage.error("发生错误,登录失败");
      });
    };

    // 根据URL中的pid获取站点名称
    onMounted(() => {
      console.log('页面加载完成！');
      // 从URL查询参数中获取pid
      const pid = route.query.pid;
      if (pid) {
        getSitename({
          pid
        }).then(res => {
          document.title = res.data.data.siteName;
          siteName.value = res.data.data.siteName; // 绑定站点名称
          bgImg.value = res.data.data.bgImg[0]; // 绑定背景图片
          localStorage.setItem('title', res.data.data.siteName);
        }).catch(() => {
          ElMessage.error("获取站点名称失败");
        });
      } else {
        console.log("URL中没有找到pid");
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([isMobile.value ? 'container' : 'containerPc']),
        style: _normalizeStyle(`background-image:url(${bgImg.value})`)
      }, [_createElementVNode("div", null, [_createElementVNode("h1", null, _toDisplayString(siteName.value), 1), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_hoisted_2, _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "用户名/账号/手机号",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => username.value = $event)
      }, null, 512), [[_vModelText, username.value]])]), _createElementVNode("div", null, [_hoisted_3, _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "请输入您的密码",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => password.value = $event)
      }, null, 512), [[_vModelText, password.value]])]), _createElementVNode("button", {
        type: "button",
        onClick: login
      }, "登陆"), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[2] || (_cache[2] = $event => _unref(router).push({
          name: 'register'
        }))
      }, "新用户注册")]), !inIFrame() ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
          name: 'weChat'
        }))
      }, _hoisted_9)])) : _createCommentVNode("", true)])])], 6);
    };
  }
};